import { Box, Container } from "@mui/material"
import { useState } from "react"
import folderCover from "../../assets/imgs/icons/folder-cover.png"
import { BookPopup } from "../modals/BookPopup"

export const RiteCharleeHero = () => {
  const [isOpenBook, setIsOpenBook] = useState(false)

  return (
    <>
      <Box className="w-full pt-24 pb-8">
        <Container maxWidth="lg">
          <Box className="w-full text-center px-6 pt-16">
            <Box
              className="w-full"
              paddingBottom={3}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <img src={folderCover} alt="ritecharlee-ico" className="riteCharlee-logo" />
              <h5 className="riteCharlee-logoTxt text-[29px] leading-[40px] font-medium mx-2">RiteCharlee</h5>
            </Box>
            <h2 className="riteCharlee-head text-[36px] md:text-[65px] leading-[39.5px] md:leading-[71.5px] font-medium">
              Risk Intelligence for Better Selection and Smarter Products
            </h2>
            <p className="riteCharlee-text mt-8">
              Built on insights from 60M+ real-world claims, RiteCharlee gives underwriting,
              actuarial, risk managers, operations managers, and product teams the risk
              intelligence they need to select the right risks, price with confidence,
              proactively reduce and control losses using risk benchmarks, and design
              offerings that perform in market.
            </p>
            <button
              onClick={() => setIsOpenBook(true)}
              className="riteCharlee-book mt-6 w-full md:w-auto rounded-full text-[18px] leading-[24px] bg-transparent border py-3 px-10 border-[#021744] text-[#021744] hover:text-white hover:bg-[#021744]"
            >
              Book a demo
            </button>
          </Box>
        </Container>
      </Box>
      <BookPopup open={isOpenBook} handleClose={() => setIsOpenBook(false)} />
    </>
  )
}
